import { cn } from '@discover-lib/utils';
import CalendarIcon from '@discover-ui/icons/calendar.svg';
import KnifeForkIcon from '@discover-ui/icons/knife-fork.svg';
import PeopleIcon from '@discover-ui/icons/people.svg';
import Separator from '@discover-ui/separator';
import { TrackProvider } from '@/components/analytics/context/AnalyticsContext';
import { type PeopleOption } from '@discover-data/stores/hooks/people/options';
import SessionSelect from '../sessionSelect';
import PeopleSelect from '../peopleSelect';
import DateSelect from '../dateSelect';

function button(className?: string) {
  return cn(
    'flex h-full min-w-0 flex-1 flex-row items-center justify-center rounded-none px-1 text-2xs font-medium outline-0 lg:min-w-36 lg:gap-2 lg:p-10 lg:text-xs',
    className
  );
}

function icon() {
  return cn('hidden text-blue lg:inline');
}

export type DesktopTopBarProps = {
  session?: string;
  peopleOptions?: PeopleOption[] | null;
  minDiners?: PeopleOption | null;
  maxDiners?: PeopleOption | null;
};

export default function DesktopTopBar({
  session,
  peopleOptions,
  minDiners,
  maxDiners,
}: DesktopTopBarProps) {
  return (
    <TrackProvider section="restaurant filters">
      <div
        data-restaurant-filter-bar
        className="container sticky top-0 z-30 hidden h-16 flex-row items-center justify-between rounded bg-white p-0 shadow-search lg:flex lg:h-28 lg:rounded-sm">
        <SessionSelect
          triggerProps={{ kind: 'outline', className: button('rounded-r') }}
          defaultValue={session}>
          <KnifeForkIcon width={18} height={18} className={icon()} />
        </SessionSelect>
        <Separator orientation="vertical" />
        <DateSelect triggerProps={{ kind: 'outline', className: button('rounded-l') }}>
          <CalendarIcon className={icon()} />
        </DateSelect>
        <Separator orientation="vertical" />
        <PeopleSelect
          peopleOptions={peopleOptions}
          minDiners={minDiners}
          maxDiners={maxDiners}
          triggerProps={{ kind: 'outline', className: button() }}>
          <PeopleIcon className={icon()} />
        </PeopleSelect>
      </div>
    </TrackProvider>
  );
}
